import { memo, useMemo } from "react";
import { LineChart } from "@ui-component-library";
import { useMetricData } from "../hooks/UseMetricData";
import { usePlusBlockerDialog } from "@components/PlusBlockerDialog/PlusBlockerDialog.context";
import { SubscriptionCoverBanner } from "../components/SubscriptionCovers";

function LineChartWidget() {
  const { valuationChartData, propDfr } = useMetricData();
  const { openPlusBlockerDialog } = usePlusBlockerDialog();

  const mappedData = useMemo(() => {
    if (!valuationChartData?.years) return undefined;
    return valuationChartData.years.map((year, index) => {
      const dataPoint = { year, unit: "kr/m³sk" };
      valuationChartData.line?.forEach((lineData, lineIndex) => {
        dataPoint[`line${lineIndex}`] = lineData.data[index];
      });
      return dataPoint;
    });
  }, [valuationChartData]);

  const lineDataset = useMemo(
    () =>
      valuationChartData?.line?.map((itm, idx) => ({
        color: "#7C6ED9",
        dataKey: `line${idx}`,
      })),
    [valuationChartData]
  );

  return (
    <div className="flex flex-col space-y-3 p-4 relative">
      {!propDfr ? (
        <SubscriptionCoverBanner
          onClick={() => openPlusBlockerDialog("property-data")}
          label="Fastighetsvärde"
        />
      ) : null}
      <div style={!propDfr ? { filter: "blur(9px)" } : {}}>
        <LineChart
          size={{
            width: "100%",
            height: 342.1053,
          }}
          lineChart={{
            data: mappedData,
            margin: {
              top: 0,
              right: 0,
              left: -20,
              bottom: 0,
            },
          }}
          xAxis={{
            dataKey: "year",
            interval: 2,
            padding: { right: 20, left: 20 }
          }}
          yAxis={{
            domain: [
              (dataMin) => Math.floor(dataMin / 100) * 100,
              (dataMax) => Math.ceil(dataMax / 100) * 100 + 50,
            ],
          }}
          dataset={lineDataset}
        ></LineChart>
      </div>
    </div>
  );
}

export default memo(LineChartWidget);
